import * as Long from "long";
import { of } from "rxjs";
import { IdResource } from "../../../../constants/IdResource";
import { selectInventoryResourceInfo } from "../../../../selectors/selectInventoryInfo";
import { selectOutskirtBuildingUpgradeGoldCost } from "../../../../selectors/selectOutskirtBuildingUpgradeInfo";
import { actionBeginBuyWithGoldProcess } from "../../../buy-with-gold/actionBuyWithGold";
import { actionOutskirtBuildingUpgradeRequest, } from "../actionOutskirtsInfo";
export var pathOutskirtBuildingUpgrade = function (action, state$, deps) {
    var state = state$.value;
    var goldCost = selectOutskirtBuildingUpgradeGoldCost(state, action.building.balancing.id);
    var upgradeRequestAction = actionOutskirtBuildingUpgradeRequest(action.building);
    if (goldCost.isPositive()) {
        var playerGoldInfo = selectInventoryResourceInfo(state, IdResource.Gold).amount || Long.ZERO;
        return of(actionBeginBuyWithGoldProcess(playerGoldInfo, goldCost, upgradeRequestAction));
    }
    return of(upgradeRequestAction);
};



//////////////////
// WEBPACK FOOTER
// ./src/features/info/outskirts/paths/pathOutskirtBuildingUpgrade.ts
// module id = 1922
// module chunks = 3